const runCalculation = () => {
	if (!!window.location.search) {
		const params = new Map<string, string>();
		const arr = window.location.search.replace('?', "").split(/&/g);
		for (let i = 0; i < arr.length; i++) {
			const equalSign = arr[i].indexOf('=');
			if (equalSign !== -1) {
				params.set(arr[i].substring(0, equalSign), arr[i].substring(equalSign + 1));
			}
		}
		document.querySelectorAll(".parameter-loading").forEach((v) => {
			const name = (v as HTMLInputElement | HTMLSelectElement).name;
			if (params.has(name)) {
				(v as HTMLInputElement | HTMLSelectElement).value = params.get(name);
			}
		})
		if (params.has("purchasePrice")) {
			(document.querySelector("#purchasePrice") as HTMLInputElement).value = params.get("purchasePrice");
		}
	}
	// cache queries
	const mortgageLoanAmount = document.querySelector("#mortgageLoanAmount");
	const mortgageMonthlyPayment = document.querySelector("#mortgageMonthlyPayment");

	const UIpurchasePrice = (document.querySelector("#purchasePrice") as HTMLInputElement).value;
	const UIdownPayment = (document.querySelector("#downPayment") as HTMLInputElement).value;
	const UIinterestRate = (document.querySelector("#interestRate") as HTMLInputElement).value;
	const UIloanTerm = (document.querySelector("#loanTerm") as HTMLInputElement).value;

	const regex = /[^0-9.]/g;
	// Convert inputs to floating point numbers
	const principal = parseFloat(UIpurchasePrice.replace(regex, ""));
	const downPayment = parseFloat(UIdownPayment.replace(regex, ""));
	const calcInterest = parseFloat(UIinterestRate.replace(regex, "")) / 100 / 12;
	const calculatedPayments = parseFloat(UIloanTerm.replace(regex, "")) * 12;

	if (isNaN(principal) || isNaN(downPayment) || isNaN(calcInterest) || isNaN(calculatedPayments)) {
		mortgageLoanAmount.innerHTML = "$0";
		mortgageMonthlyPayment.innerHTML = "$0";
	} else {
		// Calculate Loan Amount
		const totalLoanAmount = (principal - downPayment);

		// Calculate monthly payment
		const x = Math.pow(1 + calcInterest, calculatedPayments);
		const monthly = ((principal - downPayment) * x * calcInterest) / (x - 1);
		const monthlyPayment = monthly.toFixed(2);

		// Display Results
		mortgageLoanAmount.innerHTML = "$" + totalLoanAmount.toLocaleString();
		mortgageMonthlyPayment.innerHTML = "$" + monthlyPayment.toLocaleString();
	}
};

export default function initMortgageCalculators() {
	const submitButton = document.querySelector("#mortgageCalculatorForm [type='submit']");

	const maskCurrency = (event: KeyboardEvent) => {
		const eventTarget = (event.target as HTMLInputElement);
		eventTarget.value = eventTarget.value
		.replace(/[\D]/g, "")
		.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
	};
	const maskInterest = (event: KeyboardEvent) => {
		const eventTarget = (event.target as HTMLInputElement);
		eventTarget.value = eventTarget.value
		.replace(/[^0-9\.]/g, "");
	};

	if (submitButton) {
		runCalculation();

		submitButton.addEventListener("click", event => {
			event.preventDefault();
			runCalculation();
		});
		document.querySelectorAll("#mortgageCalculatorForm [name]").forEach(element => {
			if (element instanceof HTMLInputElement) {
				element.addEventListener("keyup", event => {
					if (event.key === "Enter") {
						event.preventDefault();
						runCalculation();
					}
				});
			}
			if (element instanceof HTMLSelectElement) {
				element.addEventListener("change", runCalculation);
			}
		});

		document.querySelector("#purchasePrice").addEventListener('keyup', maskCurrency);
		document.querySelector("#downPayment").addEventListener('keyup', maskCurrency);
		document.querySelector("#interestRate").addEventListener('keyup', maskInterest);
	}
};
